import { render, staticRenderFns } from "./FiltroIgnorarCompensado.vue?vue&type=template&id=3813456a&"
import script from "./FiltroIgnorarCompensado.vue?vue&type=script&lang=js&"
export * from "./FiltroIgnorarCompensado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\06.04\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3813456a')) {
      api.createRecord('3813456a', component.options)
    } else {
      api.reload('3813456a', component.options)
    }
    module.hot.accept("./FiltroIgnorarCompensado.vue?vue&type=template&id=3813456a&", function () {
      api.rerender('3813456a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Gerenciais/FiltroIgnorarCompensado.vue"
export default component.exports